module.exports = __webpack_public_path__ + "img/00049.2da0afc0.webp";